var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.01 358.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.18,31l11-31L121,16.17A112.24,112.24,0,0,1,274.27,148.1,86.46,86.46,0,0,0,149.61,49.67l14,16.42L121.5,73.92,78.16,82Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.31,206.75l-11,31-13.82-16.16A112.24,112.24,0,0,1,58.22,89.7a86.46,86.46,0,0,0,124.66,98.42l-14-16.42L211,163.87l43.34-8.05Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.08,309.5a79.55,79.55,0,0,1,13.44-1.05c7,0,11.71,1.17,15,3.91a12.24,12.24,0,0,1,4.19,9.75,12.85,12.85,0,0,1-8.83,12.13v.2c3.51,1.33,5.56,4.68,6.77,9.39,1.54,6.08,2.86,11.64,3.83,13.53H30.34c-.75-1.4-1.91-5.41-3.27-11.45-1.39-6.33-3.69-8.38-8.73-8.49H13.88v19.94H5.08Zm8.8,21.42h5.24c6,0,9.72-3.17,9.72-8,0-5.28-3.72-7.76-9.45-7.78a24.76,24.76,0,0,0-5.51.45Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.21,335.83H54.92v14.24H75.37v7.29H46.05V308.83H74.3v7.29H54.92V328.6H73.21Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.13,309.5a73.76,73.76,0,0,1,12.94-1.05c6.51,0,10.58.84,13.89,3.08a10.36,10.36,0,0,1,5,9.13c0,4.46-2.78,8.53-8.07,10.46v.19c5.12,1.3,9.82,5.34,9.82,12a12.78,12.78,0,0,1-4.65,10c-3.46,3-9.14,4.48-18,4.48a83.06,83.06,0,0,1-10.9-.64Zm8.8,19.16h4.54c6.15,0,9.56-2.9,9.56-7,0-4.56-3.45-6.65-9-6.65a24,24,0,0,0-5.07.39Zm0,22.26a28.09,28.09,0,0,0,4.69.25c5.67,0,10.77-2.13,10.77-8.12,0-5.64-5-7.95-11.06-8h-4.4Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.76,335.83H133.47v14.24h20.45v7.29H124.6V308.83h28.25v7.29H133.47V328.6h18.29Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.41,343.64l-4.14,13.72H158.1l15.58-48.53H185l15.77,48.53h-9.52l-4.39-13.72Zm14-6.7-3.82-12c-.94-3-1.74-6.3-2.47-9.12h-.16c-.7,2.85-1.45,6.21-2.31,9.09l-3.74,12Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214,308.83v28.29c0,9.49,3.94,13.91,10,13.91,6.38,0,10.22-4.38,10.22-13.91V308.83H243v27.72c0,14.95-7.69,21.6-19.41,21.6-11.2,0-18.5-6.28-18.5-21.55V308.83Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.44,316.28H248.58v-7.45H285.3v7.45h-14v41.08h-8.87Z",
    transform: "translate(-5.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.1,357.36v-20.2l-15.35-28.33h10.14l5.78,12.45c1.65,3.58,2.91,6.33,4.23,9.62h.15c1.19-3.1,2.58-6.09,4.2-9.64l5.84-12.43h10L312,336.91v20.45Z",
    transform: "translate(-5.08)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.991b3e8c8f81704d56576e1ce7792b36.svg";
export { ForwardRef as ReactComponent };